import { InputRef, Modal } from 'antd';
import { AppInput } from '@components/form/input/app-input';
import { AddTeamModalProps } from '../team-management.types';
import { AppModal } from '@components/form/Modal';
import { CursorPaginatedSelect } from '@components/form/cursor-paginated-select/cursor-paginated-select';
import { useRef, useState } from 'react';
import useWorkspaceMembers from '@modules/settings/team-detail/hooks/use-workspace-members';
import { FormWrapper } from '@components/form/form-wrapper/form-wrapper';
import { useTranslation } from 'react-i18next';
import { capitalize } from '@shared/utils/capitalize';

export function ModalCreateTeamView({
  isOpen,
  closeModal,
  onSubmit,
  control,
  loading: createTeamLoading,
}: AddTeamModalProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const workspaceMembers = useWorkspaceMembers({ query: searchQuery });
  const { t } = useTranslation();
  const nameInputRef = useRef<InputRef>(null);

  return (
    <Modal
      className="prevent-click-outside"
      centered
      onCancel={closeModal}
      open={isOpen}
      classNames={{ content: 'max-w-[420px]' }}
      afterOpenChange={(isOpen) => isOpen && nameInputRef?.current?.focus()}
      title={
        <AppModal.Header>
          <AppModal.Title className="capitalize!">{t('add_team')}</AppModal.Title>
          <AppModal.SubTitle>{t('create_a_team_to_group_members_for_structure_and_growth')}</AppModal.SubTitle>
        </AppModal.Header>
      }
      footer={
        <AppModal.Footer>
          <AppModal.Button className="w-full capitalize!" onClick={closeModal}>
            {t('cancel')}
          </AppModal.Button>
          <AppModal.Button
            type="primary"
            className="w-full capitalize!"
            htmlType="submit"
            onClick={onSubmit}
            loading={workspaceMembers?.loading || createTeamLoading}
            data-test-id="settings-team-add-saveMember"
          >
            {t('save_one')}
          </AppModal.Button>
        </AppModal.Footer>
      }
    >
      <div className="space-y-2 mt-4">
        <FormWrapper onSubmit={onSubmit} className="w-full space-y-5 mb-4">
          <div className="space-y-4">
            <AppInput
              ref={nameInputRef}
              name="name"
              control={control}
              label={capitalize(t('name'))}
              required
              placeholder={t('new_team_name')}
            />

            <CursorPaginatedSelect
              name="members"
              placeholder={capitalize(t('select_members'))}
              label={capitalize(t('member_other'))}
              control={control}
              cursor={workspaceMembers?.data?.cursor}
              options={workspaceMembers?.getSelectOptions()}
              className="app-select"
              classNames={{ popup: { root: 'prevent-click-outside' } }}
              loadMoreRef={workspaceMembers?.loadNextRef}
              setSearchQuery={setSearchQuery}
              loading={workspaceMembers?.loading}
              mode="multiple"
              allowClear
              required
            />
          </div>
        </FormWrapper>
      </div>
    </Modal>
  );
}
